import React from 'react'
import { IconBaseProps, IconName, SvgProps } from './Icon.types'
import { IconStyled } from './Icon.styles'
import { ICONS_MAP } from './Icon.consts'

export interface ComponentProps extends IconBaseProps, SvgProps {
  /**
   * Custom source of the icon
   */
  src?: string

  /**
   * Or name of the shared icon from `Icons` enum
   */
  name?: IconName
}

const Icon = React.forwardRef<SVGElement, ComponentProps>(({ src, name, size = 'small', ...otherProps }: ComponentProps, ref) => {
  const source = (name && ICONS_MAP[name]) || src

  return source ? <IconStyled src={source} size={size} innerRef={ref} {...otherProps} /> : null
})

Icon.displayName = 'Icon'
export default Icon
